import { render, staticRenderFns } from "./ModalAnswers.vue?vue&type=template&id=7f656794&"
import script from "./ModalAnswers.vue?vue&type=script&lang=js&"
export * from "./ModalAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports